import T from "./design-system.es44.js";
import { resolveComponent as b, openBlock as s, createElementBlock as n, createElementVNode as d, renderSlot as y, createTextVNode as a, normalizeClass as g, createCommentVNode as f, Fragment as h, renderList as u, createVNode as k, createBlock as w, withModifiers as L, withCtx as v, normalizeStyle as F } from "vue";
/* empty css                    */
import V from "./design-system.es128.js";
import G from "./design-system.es87.js";
import U from "./design-system.es61.js";
import B from "./design-system.es324.js";
import N from "./design-system.es325.js";
import E from "./design-system.es104.js";
import H from "./design-system.es116.js";
import M from "./design-system.es298.js";
import { createActionsProvider as P } from "./design-system.es31.js";
/* empty css                    */
/* empty css                    */
const q = {
  name: "DsTableGrid",
  components: {
    TableGridHeader: B,
    TableGridCell: N,
    TableGridTrowser: E,
    Checkbox: T,
    Placeholder: G,
    InfiniteScroll: U
  },
  props: {
    /**
     * Array of data to render in the table
     */
    data: Array,
    /**
     * Number of infinite scroll elements at a time
     */
    limit: Number,
    /**
     * Two way binding of the select all option being active
     */
    selectAll: Boolean,
    /**
     * Allow rows to be selectable
     */
    selectable: Boolean,
    /**
     * Toggle to show loading state
     */
    showLoading: Boolean,
    /**
     * Id of the data field you want to sort by
     */
    sortField: {
      type: String,
      default: ""
    },
    /**
     * Toggle to sort ascending/descending
     */
    sortAscending: Boolean,
    /**
     * Infinite scrolling of loading data
     */
    infinite: Boolean,
    /**
     * Px threshold of when to load more rows in table
     */
    threshold: Number,
    /**
     * Debounce delay of loading more rows in infinite srolling
     */
    debounceDelay: Number,
    /**
     * Height in px of the placeholder row
     */
    placeholderHeight: Number,
    /**
     * Label of the selected items to display in the table
     */
    selectedItemLabel: String,
    /**
     * Label value event names of options to take with selected rows
     * */
    selectedOptions: Array,
    /**
     * Total number of rows for when select all is checked
     */
    total: Number,
    /**
     * Initial value of selected rows or unselected if selecting all with infinite
     */
    modelValue: {
      type: Array,
      default: () => []
    },
    /**
     * Action taken when row is clicked
     */
    clickRow: Function
  },
  emits: [
    "action",
    "load",
    "sort",
    "update:limit",
    "update:modelValue",
    "update:selectAll"
  ],
  setup(t) {
    const e = H(), { containsEventTarget: l } = P();
    function m(i, c) {
      typeof t.clickRow == "function" && !l(c) && t.clickRow(i, c);
    }
    return {
      i18n: e,
      performAction: m
    };
  },
  data() {
    return {
      optimalLimit: this.limit || 1,
      loading: !0,
      noMoreData: !1,
      allSelected: this.selectAll,
      checkboxData: [],
      columns: [],
      localSortField: this.sortField,
      localSortAscending: this.sortAscending,
      placeholder: [{ height: "0.5rem", boxes: [1] }],
      sortable: !!this.sortField,
      selectedRows: this.modelValue
    };
  },
  computed: {
    someSelected() {
      return this.selectedCount > 0;
    },
    selectedCount() {
      return this.trackUnselected ? this.total - this.selectedRows.length : this.selectedRows.length;
    },
    trackUnselected() {
      return this.infinite && this.allSelected;
    },
    partialSelection() {
      const t = this.infinite && this.selectedRows.length > 0, e = !this.infinite && this.selectedRows.length < this.data.length;
      return this.allSelected && (t || e);
    }
  },
  watch: {
    checkboxData: {
      handler(t) {
        this.selectedRows = t.reduce((e, { checked: l, rowIndex: m }) => ((l && !this.trackUnselected || !l && this.trackUnselected) && e.push(m), e), []), this.$emit("update:modelValue", this.selectedRows);
      },
      deep: !0
    },
    allSelected(t) {
      this.$emit("update:selectAll", t);
    },
    data: {
      handler() {
        this.selectable && this.updateCheckboxData();
      },
      deep: !0
    },
    showLoading(t) {
      this.loading = t;
    },
    sortField(t) {
      this.localSortField = t, this.emitSort();
    },
    sortAscending(t) {
      this.localSortAscending = t, this.emitSort();
    },
    modelValue(t, e) {
      this.selectable && !M(t, e) && (this.selectedRows = t, this.updateCheckboxData());
    }
  },
  created() {
    this.loading = !this.data.length, this.selectable && this.updateCheckboxData();
  },
  methods: {
    isSelected(t) {
      return this.trackUnselected ? !this.selectedRows.includes(t) : this.selectedRows.includes(t);
    },
    updateCheckboxData() {
      this.data.length && (this.checkboxData = this.data.map((t, e) => {
        const l = this.trackUnselected ? !this.selectedRows.includes(e) : this.selectedRows.includes(e);
        return {
          rowIndex: e,
          checked: l,
          error: !1,
          disabled: !1
        };
      }));
    },
    selectedAction(t) {
      this.$emit("action", t);
    },
    handlerRowClick(t) {
      this.checkboxData[t].checked = !this.checkboxData[t].checked;
    },
    handleSelectAll(t) {
      this.checkboxData.forEach((e) => {
        e.checked = t;
      });
    },
    reset() {
      this.noMoreData = !1, this.resetSelections();
    },
    finishLoading() {
      this.noMoreData = !0;
    },
    load() {
      this.limit < this.optimalLimit ? (this.$emit("update:limit", this.optimalLimit), this.$nextTick(() => {
        this.$emit("load");
      })) : this.$emit("load");
    },
    register(t) {
      this.columns.push(t);
    },
    resetSelections() {
      this.selectedRows = [], this.allSelected = !1, this.updateCheckboxData();
    },
    sort(t) {
      this.sortable && t.sortable && (this.localSortAscending = t.property === this.localSortField ? !this.localSortAscending : !0, this.localSortField = t.property, this.emitSort());
    },
    emitSort() {
      this.resetSelections(), this.$emit("sort", {
        field: this.localSortField,
        ascending: this.localSortAscending
      });
    }
  }
}, z = { class: "table-grid" }, O = { class: "hidden-columns" }, W = {
  key: 0,
  name: "checkbox",
  width: 70
}, j = ["name", "width"], I = {
  key: 0,
  class: "column-checkbox"
}, J = ["onClick"], K = {
  key: 0,
  name: "checkbox",
  width: 70
}, Q = ["name", "width"], X = { key: 0 };
function Y(t, e, l, m, i, c) {
  const p = b("Checkbox"), C = b("TableGridHeader"), A = b("TableGridCell"), D = b("Placeholder"), R = b("InfiniteScroll"), x = b("TableGridTrowser");
  return s(), n("div", z, [
    d("div", O, [
      y(t.$slots, "default", {}, void 0, !0)
    ]),
    e[11] || (e[11] = a()),
    d("div", {
      class: g(["table-wrapper", { "trowser-active": i.allSelected }])
    }, [
      d("table", null, [
        d("colgroup", null, [
          l.selectable ? (s(), n("col", W)) : f("", !0),
          e[2] || (e[2] = a()),
          (s(!0), n(h, null, u(i.columns, (o, r) => (s(), n("col", {
            key: r,
            name: `col-th-${o.id}`,
            width: o.expand ? "" : o.width
          }, null, 8, j))), 128))
        ]),
        e[5] || (e[5] = a()),
        d("thead", null, [
          d("tr", null, [
            l.selectable ? (s(), n("th", I, [
              k(p, {
                modelValue: i.allSelected,
                "onUpdate:modelValue": [
                  e[0] || (e[0] = (o) => i.allSelected = o),
                  c.handleSelectAll
                ],
                class: "selectAll",
                partial: c.partialSelection
              }, null, 8, ["modelValue", "partial", "onUpdate:modelValue"])
            ])) : f("", !0),
            e[3] || (e[3] = a()),
            (s(!0), n(h, null, u(i.columns, (o) => (s(), w(C, {
              key: o.id,
              column: o,
              "sort-field": i.localSortField,
              "sort-ascending": i.localSortAscending,
              onClick: (r) => c.sort(o)
            }, null, 8, ["column", "sort-field", "sort-ascending", "onClick"]))), 128))
          ])
        ]),
        e[6] || (e[6] = a()),
        d("tbody", null, [
          (s(!0), n(h, null, u(l.data, (o, r) => (s(), n("tr", {
            key: r,
            ref_for: !0,
            ref: "row",
            class: g({ "selected-row": c.isSelected(r), "selectable-row": l.clickRow })
          }, [
            l.selectable ? (s(), n("td", {
              key: 0,
              class: g(["column-checkbox", { selectable: l.selectable }]),
              onClick: L((S) => c.handlerRowClick(r), ["prevent"])
            }, [
              i.checkboxData[r] ? (s(), w(p, {
                key: 0,
                ref_for: !0,
                ref: "checkbox",
                "model-value": i.checkboxData[r].checked,
                "data-qa": o.fullName || r,
                error: i.checkboxData[r].error,
                disabled: i.checkboxData[r].disabled
              }, null, 8, ["model-value", "data-qa", "error", "disabled"])) : f("", !0)
            ], 10, J)) : f("", !0),
            e[4] || (e[4] = a()),
            (s(!0), n(h, null, u(i.columns, (S) => (s(), w(A, {
              key: S.id,
              data: o,
              column: S,
              onClick: (_) => m.performAction(o, _)
            }, null, 8, ["data", "column", "onClick"]))), 128))
          ], 2))), 128))
        ])
      ]),
      e[10] || (e[10] = a()),
      k(R, {
        key: "InfiniteScroll",
        limit: i.optimalLimit,
        "onUpdate:limit": e[1] || (e[1] = (o) => i.optimalLimit = o),
        "no-more-data": i.noMoreData,
        loading: i.loading,
        disabled: !l.infinite,
        threshold: l.threshold,
        "debounce-delay": l.debounceDelay,
        onLoad: c.load
      }, {
        default: v(() => [
          d("table", null, [
            d("colgroup", null, [
              l.selectable ? (s(), n("col", K)) : f("", !0),
              e[7] || (e[7] = a()),
              (s(!0), n(h, null, u(i.columns, (o, r) => (s(), n("col", {
                key: r,
                name: `col-th-${o.id}`,
                width: o.width
              }, null, 8, Q))), 128))
            ]),
            e[9] || (e[9] = a()),
            d("tbody", null, [
              (s(), n(h, null, u(3, (o) => d("tr", {
                key: o,
                style: F({ height: `${l.placeholderHeight}px` }),
                class: "placeholder"
              }, [
                l.selectable ? (s(), n("td", X, [
                  k(p, { disabled: "" })
                ])) : f("", !0),
                e[8] || (e[8] = a()),
                (s(!0), n(h, null, u(i.columns, ({ id: r }) => (s(), n("td", { key: r }, [
                  k(D, { rows: i.placeholder }, null, 8, ["rows"])
                ]))), 128))
              ], 4)), 64))
            ])
          ])
        ]),
        _: 1
      }, 8, ["limit", "no-more-data", "loading", "disabled", "threshold", "debounce-delay", "onLoad"])
    ], 2),
    e[12] || (e[12] = a()),
    y(t.$slots, "trowser", {}, () => [
      k(x, {
        "selected-count": c.selectedCount,
        "selected-item-label": l.selectedItemLabel || m.i18n.messages["tablegrid.selected"],
        "selected-options": l.selectedOptions,
        show: c.someSelected,
        onSelectedClicked: c.selectedAction
      }, null, 8, ["selected-count", "selected-item-label", "selected-options", "show", "onSelectedClicked"])
    ], !0)
  ]);
}
const ue = /* @__PURE__ */ V(q, [["render", Y], ["__scopeId", "data-v-6ef5a64b"]]);
export {
  ue as default
};
//# sourceMappingURL=design-system.es102.js.map
